import { call, takeEvery } from 'redux-saga/effects'
import { SAGA_ERROR } from 'ducks/error'
import { stringify } from 'utils/json'

export default function* errorSaga() {
  yield takeEvery(SAGA_ERROR, logError)
}

function* logError(action) {
  yield call(console.error, stringify(action))
}
